import axios from "axios";
import { api_urls } from "../api-urls";

export const getAPI = async (url) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(api_urls + url, { headers: { Authorization: 'Bearer ' + token } });
        return response;
    } catch (error) {
        console.warn(`[getAPI Error] ${url}:`, error?.response?.status || error?.message);
        return error?.response || { data: { success: false, message: error?.message } };
    }
};

export const postAPI = async (url, payload) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(api_urls + url, payload, { headers: { Authorization: 'Bearer ' + token } });
        return response;
    } catch (error) {
        console.warn(`[postAPI Error] ${url}:`, error?.response?.status || error?.message);
        return error?.response || { data: { success: false, message: error?.message } };
    }
};

export const putAPI = async (url, payload) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.put(api_urls + url, payload, { headers: { Authorization: 'Bearer ' + token } });
        return response;
    } catch (error) {
        console.warn(`[putAPI Error] ${url}:`, error?.response?.status || error?.message);
        return error?.response || { data: { success: false, message: error?.message } };
    }
};

export const patchAPI = async (url, payload) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.patch(api_urls + url, payload, { headers: { Authorization: 'Bearer ' + token } });
        return response;
    } catch (error) {
        console.warn(`[patchAPI Error] ${url}:`, error?.response?.status || error?.message);
        return error?.response || { data: { success: false, message: error?.message } };
    }
};

export const deleteAPI = async (url) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.delete(api_urls + url, { headers: { Authorization: 'Bearer ' + token } });
        return response;
    } catch (error) {
        console.warn(`[deleteAPI Error] ${url}:`, error?.response?.status || error?.message);
        return error?.response || { data: { success: false, message: error?.message } };
    }
};